<script>
import {
  campaignMethods,
  prospectComputed,
  prospectMethods,
} from '@/src/state/helpers';

export default {
  components: {},
  props: {
    prospect: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      showEditText: false,
    };
  },
  computed: {
    ...prospectComputed,
    selectedEmail() {
      return this.prospect?.selectedCommsOpt === 'email';
    },
    selectedSms() {
      return this.prospect?.selectedCommsOpt === 'phone';
    },
    isEdited() {
      return this.prospect?.message;
    },
    hasPhoneNumbers() {
      return this.prospect?.connectionOptions?.some(
        (opt) => opt.type === 'phone'
      );
    },
    hasEmailAddresses() {
      return this.prospect?.connectionOptions?.some(
        (opt) => opt.type === 'email'
      );
    },
  },
  methods: {
    ...campaignMethods,
    ...prospectMethods,
    selectProspect(prospect) {
      this.setSelectedProspect(prospect);
    },
    selectCommsOpt(type, prospect) {
      if (
        (type === 'phone' && this.hasPhoneNumbers) ||
        (type === 'email' && this.hasEmailAddresses)
      ) {
        if (prospect?.selectedCommsOpt && prospect?.selectedCommsOpt === type) {
          this.setRemoveCampaignRecipient(prospect);
          this.setProspectSelectedCommsOpt({ type: null, prospect });
        } else if (prospect?.selectedCommsOpt) {
          this.setProspectSelectedCommsOpt({ type, prospect });
          this.setRecipientSelectedCommsOpt({ type, prospect });
        } else {
          this.setAddCampaignRecipient({ type, prospect });
          this.setProspectSelectedCommsOpt({ type, prospect });
          this.setRecipientSelectedCommsOpt({ type, prospect });
        }
      }
    },
    isProspectSelected(prospect) {
      if (this.selectedProspect) {
        return prospect._id === this.selectedProspect._id;
      }
    },
  },
};
</script>

<template>
  <li
    :class="['contact-list-item', { selected: isProspectSelected(prospect) }]"
    @click="selectProspect(prospect)"
  >
    <div class="prospect-details">
      <img src="@assets/images/placeholder-avatar.png" />
      <p
        ><span>{{ prospect.firstName }}</span> {{ prospect.lastName }}</p
      >
    </div>
    <div class="prospect-options">
      <span class="prospect-action">
        <span class="click-edit" v-if="!isProspectSelected(prospect)"
          >Click to edit</span
        >
        <span class="is-edited" v-if="isEdited">Edited</span>
      </span>
      <span
        :class="[
          'icon-wrapper mobile',
          { selected: selectedSms, disabled: !hasPhoneNumbers },
        ]"
        @click.stop="selectCommsOpt('phone', prospect)"
      >
        <BaseIcon name="mobile" />
      </span>
      <span
        :class="[
          'icon-wrapper envelope',
          { selected: selectedEmail, disabled: !hasEmailAddresses },
        ]"
        @click.stop="selectCommsOpt('email', prospect)"
      >
        <BaseIcon name="envelope" />
      </span>
    </div>
  </li>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-max-type
// stylelint-disable no-descending-specificity

.contact-list-item {
  align-items: center;
  display: flex;
  height: 5.6rem;
  justify-content: space-between;
  padding: 0.8rem 1.6rem;

  .prospect-details {
    align-items: center;
    display: flex;

    img {
      border-radius: $border-radius-circle;
      height: 4rem;
      margin-right: 1.6rem;
      width: 4rem;
    }

    p {
      font-size: 1.4rem;
      letter-spacing: -0.257143px;
      line-height: 2.4rem;
      margin-bottom: 0;

      span {
        font-weight: bold;
      }
    }
  }

  .prospect-options {
    display: flex;

    .prospect-action {
      color: $color-heading-text;
      font-weight: bold;
      margin-right: 1.6rem;

      .click-edit {
        display: none;
        font-style: italic;
      }
    }

    .icon-wrapper {
      align-items: center;
      background-color: $color-off-white-seven;
      border-radius: $border-radius-circle;
      display: flex;
      height: 3rem;
      justify-content: center;
      width: 3rem;

      &:not(:last-child) {
        margin-right: 1.6rem;
      }

      .fa-mobile,
      .fa-envelope {
        color: $color-medium-gray-six;
      }

      &.mobile.selected,
      &.envelope.selected {
        background-color: $color-primary;

        .fa-mobile,
        .fa-envelope {
          color: white;
        }
      }

      &.disabled:hover {
        cursor: not-allowed;
      }
    }
  }

  &:hover {
    background-color: $color-light-gray-twenty;
    cursor: pointer;

    .prospect-action {
      font-weight: normal;
      opacity: 0.5;

      .click-edit {
        display: block;
      }

      .is-edited {
        display: none;
      }
    }
  }

  &.selected {
    background-color: $color-primary;

    .prospect-details p {
      color: white;
    }

    .icon-wrapper {
      align-items: center;
      background-color: $color-off-white-seven;
      border-radius: $border-radius-circle;
      display: flex;
      height: 3rem;
      justify-content: center;
      width: 3rem;

      &:not(:last-child) {
        margin-right: 1.6rem;
      }

      .fa-mobile,
      .fa-envelope {
        color: $color-medium-gray-six;
      }

      &.mobile.selected,
      &.envelope.selected {
        background-color: white;

        .fa-mobile,
        .fa-envelope {
          color: $color-primary;
        }
      }
    }
  }
}
</style>
